import { Component, ViewChild, OnInit, EventEmitter, Output, Input, AfterViewInit } from '@angular/core'
import { jqxTreeGridComponent } from 'jqwidgets-ng/jqxtreegrid'
import { CurrentUserGateway } from '../../gateways/current-user-gateway'
import { OrgHierarchy } from '../../models/orgHeirarchy'
import { CommonGateway } from '../../gateways/common-gateway'
import { CurrentUser } from '../../models/current-user'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'jq-org-dropdown-multiselect',
    templateUrl: 'org-treeview-multiselect.component.html'
})
export class OrgTreeViewMultiSelect implements OnInit, AfterViewInit {
    @ViewChild('myTree', { static: true }) myTree: jqxTreeGridComponent

    jqx: any
    organizations: OrgHierarchy[] = [] as OrgHierarchy[]
    noneField: OrgHierarchy = {} as OrgHierarchy
    @Input() disabled: boolean = false
    @Input() width: number = 327
    @Output() onValueChange: EventEmitter<string[]> = new EventEmitter<string[]>()

    currentUser: CurrentUser = {} as CurrentUser
    selectedOrgs: string[] = []

    source = {
        datatype: 'json',
        datafields: [{ name: 'CurrentOrgID' }, { name: 'CurrentOrgParentOrgID' }, { name: 'text' }, { name: 'value' }],
        hierarchy: {
            keyDataField: { name: 'CurrentOrgID' },
            parentDataField: { name: 'CurrentOrgParentOrgID' }
        },
        id: 'CurrentOrgID',
        localdata: this.organizations
    }
    dataAdapter = new jqx.dataAdapter(this.source)
    columns = [{ text: 'Org Name', dataField: 'text' }]

    constructor(private _commonGateway: CommonGateway, private _currentUserGateway: CurrentUserGateway, private _global: PortalGlobals) {}

    ready(): void {
        // this.myTree.expandRow(2)
        this.myTree.expandAll()
    }

    ngOnInit() {
        this.noneField.CurrentOrgID = null
        this.noneField.CurrentOrgParentOrgID = 0
        this.noneField.text = 'All'
        this.noneField.value = '0'
        this._currentUserGateway.getCurrentUser().subscribe((user: CurrentUser) => {
            this.currentUser = user
            if (this._global.currentUser.IsGuruAdmin || this._global.currentUser.IsSuperAdminAdmin) {
                //if (this.currentUser.roleId === 1 || this.currentUser.roleId === 2) {
                this.organizations.push(this.noneField)
            }
            this.getParents()
        })
    }

    ngAfterViewInit(): void {}

    private getParents() {
        let OrgId
        if (this.currentUser.IsSuperAdminAdmin || this.currentUser.IsGuruAdmin) OrgId = this.currentUser.insuranceCompanyId
        else OrgId = this.currentUser.orgId

        this._commonGateway.getOrgHierarchy(OrgId).subscribe((model: OrgHierarchy[]) => {
            let orgdata: OrgHierarchy[] = model
            for (let i = 0; i < orgdata.length; i++) {
                this.organizations.push(orgdata[i])
            }
            this.source.localdata = this.organizations
            this.dataAdapter.dataBind()
            this.myTree.updateBoundData()
            this.myTree.expandAll()
        })
    }

    rowCheck(event: any): void {
        if (this.selectedOrgs.indexOf(event.args.row.CurrentOrgID) == -1) {
            this.selectedOrgs.push(event.args.row.CurrentOrgID)
        }
        this.onValueChange.emit(this.selectedOrgs)
    }

    rowUncheck(event: any): void {
        this.selectedOrgs = this.selectedOrgs.filter((item) => item !== event.args.row.CurrentOrgID)
        this.onValueChange.emit(this.selectedOrgs)
    }
}
